import { memo } from 'react';

import { CaptionVideoTaskPanelItemCompleted } from '~/components/CaptionVideoTasks/CaptionVideoTaskPanelItemCompleted';
import { CaptionVideoTaskPanelItemFailed } from '~/components/CaptionVideoTasks/CaptionVideoTaskPanelItemFailed';
import { CaptionVideoTaskPanelItemInProgress } from '~/components/CaptionVideoTasks/CaptionVideoTaskPanelItemInProgress';
import { type CaptionVideoTask } from '~/components/CaptionVideoTasks/types';
import { PaneContainer } from '~/components/FileStatusTrackingPane/PaneContainer';

export type CaptionVideoTasksPanelProps = {
  tasks: CaptionVideoTask[];
  onCancel: (localTaskId: string) => void;
  onClear: (localTaskId: string) => void;
};

export const CaptionVideoTasksPanel = memo(({ tasks, onCancel, onClear }: CaptionVideoTasksPanelProps) => {
  return (
    <div data-testid="CAPTION_VIDEO_TASK_PANEL">
      {tasks.map((task) => {
        return (
          <PaneContainer key={task.localTaskId} className="mb-2 last:mb-0">
            {task.status === 'in-progress' || task.status === 'pending' ? (
              <CaptionVideoTaskPanelItemInProgress
                metadata={task.metadata}
                onCancel={() => onCancel(task.localTaskId)}
              />
            ) : null}
            {task.status === 'completed' ? (
              <CaptionVideoTaskPanelItemCompleted metadata={task.metadata} onClear={() => onClear(task.localTaskId)} />
            ) : null}
            {task.status === 'error' ? (
              <CaptionVideoTaskPanelItemFailed metadata={task.metadata} onClear={() => onClear(task.localTaskId)} />
            ) : null}
          </PaneContainer>
        );
      })}
    </div>
  );
});

CaptionVideoTasksPanel.displayName = 'CaptionVideoTasksPanel';
